import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import apiClient from "./apiClient";

// Fetch trainers assigned to a specific ICT
export const fetchTrainersByIctId = createAsyncThunk(
  "ictTrainers/fetchByIctId",
  async (ictId, { rejectWithValue }) => {
    try {
      const response = await apiClient.get(`/ictData/${ictId}/trainers`);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

// Assign trainer to ICT via /ictData/trainers/associate (multipart/form-data)
export const insertTrainersForIct = createAsyncThunk(
  "ictTrainers/insertTrainersForIct",
  async ({ ict_id, trainer_id }, { rejectWithValue }) => {
    try {
      const formData = new FormData();
      formData.append("ict_id", ict_id);
      formData.append("trainer_id", trainer_id);

      const response = await apiClient.post("/ictData/trainers/associate", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);


// ——— Fetch all ICTData linked to a specific trainer ———
export const fetchIctDataByTrainerId = createAsyncThunk(
  "ictTrainers/fetchIctDataByTrainerId",
  async (trainer_id, { rejectWithValue }) => {
    try {
      const response = await apiClient.get(`/trainers/${trainer_id}/ictData`);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);



// Slice
const ictTrainersByIctIdSlice = createSlice({
  name: "ictTrainersByIctId",
  initialState: {
    data: [],
    ictDataByTrainer: [], 
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchTrainersByIctId.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchTrainersByIctId.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchTrainersByIctId.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(insertTrainersForIct.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(insertTrainersForIct.fulfilled, (state, action) => {
        state.loading = false;
        // Optionally update state.data with returned list of trainers
        if (Array.isArray(action.payload)) {
          state.data = action.payload;
        }
      })
      .addCase(insertTrainersForIct.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      
      .addCase(fetchIctDataByTrainerId.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchIctDataByTrainerId.fulfilled, (state, action) => {
        state.loading = false;
        state.ictDataByTrainer = action.payload;
      })
      .addCase(fetchIctDataByTrainerId.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default ictTrainersByIctIdSlice.reducer;
